import { useMemo, useState } from "react"
import { Ticket } from "../../../../redux/slices/ticket/ticketModel"
import MaterialReactTable, { MRT_ColumnDef, MRT_Row } from "material-react-table"
import moment from "moment"
import { useGetAllTicketsQuery } from "../../../../redux/slices/ticket/apiTicketSlice"
import { Box } from "@mui/material"
import { TableTicketProcess } from "./TableTicketProcess"
import { useAppDispatch } from "../../../../redux/hook"
import { setDrawerTicket } from "../../../../redux/slices/ticket/ticketSlice"
import { Link } from "react-router-dom"

type Props = {
  className: string,

}

const TableTicket: React.FC<Props> = ({ className }) => {
  const dispatch = useAppDispatch()
  const createTicket = () => {
    dispatch(setDrawerTicket({
      id: ""
    }))
  }

  const { data: tickets } = useGetAllTicketsQuery(1, { refetchOnMountOrArgChange: true })
  const tp: Ticket = {
    id: "",
    deviceId: "",
    groupName: "",
    reference: "",
    statusId: 0,
    created_at: null,
    updated_at: null,
    processes: [],
  }
  const [ticketProcess, setTicketProcess] = useState(tp)

  const ticketColumns = useMemo<MRT_ColumnDef<Ticket>[]>(
    () => [
      {
        accessorKey: 'groupName',
        header: 'Device',
        maxSize: 50,
        enableGrouping: true,
        enableEditing: false, //disable editing on this column    
        enableHiding: false,  //disable column hiding for this column,
        enableColumnOrdering: false,  //disable column ordering for this column,      

        Cell: ({ cell }) => (
          <div className='d-flex align-items-center'>
            <span className='text-capitalize'>{cell.getValue<string>()}</span>
          </div>
        ),
      },
      {
        accessorKey: 'reference',
        header: 'Reference',
        enableGrouping: true,
        enableEditing: false, //disable editing on this column    
        enableHiding: false,  //disable column hiding for this column,
        enableColumnOrdering: false,  //disable column ordering for this column,      

        Cell: ({ cell }) => (
          <div className='d-flex align-items-center'>
            <span className='text-capitalize'>{cell.getValue<string>()}</span>
          </div>
        ),
      },
      {
        accessorKey: 'statusId',
        header: 'Status',
        enableGrouping: true,
        enableEditing: false, //disable editing on this column    
        enableHiding: false,  //disable column hiding for this column,
        enableColumnOrdering: false,  //disable column ordering for this column,      

        Cell: ({ row }) => {
          return (
            <>
              {row.original.statusId == 3 ? <div className="badge badge-light-success fw-bolder">Closed</div> : <div className="badge badge-light-info fw-bolder">Open</div>}
            </>
          )

        },
      },
      {
        accessorKey: 'created_at',
        header: 'Created At',
        enableColumnOrdering: false,
        enableEditing: false,
        enableSorting: true,
        Cell: ({ cell }) => (
          <div className={`d-flex text-muted justify-content-end tooltip-bottom`} >
            {moment(moment.utc(cell.getValue<string>()).toDate()).format("DD-MMM-YYYY  HH:mm:ss A")}
          </div>
        ),
      },
      {
        accessorKey: 'updated_at',
        header: 'Last updated',
        enableColumnOrdering: false,
        enableEditing: false,
        enableSorting: true,
        Cell: ({ cell }) => (
          <div className={`d-flex text-muted justify-content-end tooltip-bottom`} >
            {moment(moment.utc(cell.getValue<string>()).toDate()).format("DD-MMM-YYYY  HH:mm:ss A")}
          </div>
        ),
      },
      {
        accessorKey: 'processes',
        header: 'Action',
        resizable: false,
        size: 150,
        Cell: ({ cell, row }) => (
          <button className="btn btn-secondary btn-sm" onClick={() => {
            setTicketProcess(row.original);
          }}>View detail</button>
        ),
      },
    ], []
  )
  return (
    <>
      {ticketProcess.id !== "" &&
        <TableTicketProcess
          className="bg-light m-0 p-0 border-bottom-0"
          ticket={ticketProcess}
        />
      }
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Resolution Center</h3>
          </div>
          <div className="float-end mt-4">
          <Link
          to={`../feature-request`}
          className='btn btn-primary align-self-center me-5'
          >Request Features</Link>
          <button
            className='btn btn-primary align-self-center'
            data-bs-toggle="offcanvas"

            data-bs-target="#kt_drawer_reply_ticket"
            id="kt_drawer_create_ticket_button"
            data-kt-drawer-show="true"
            onClick={() => {
              setTicketProcess(tp);
              createTicket()
            }}
          >Create ticket</button>
          </div>
        </div>
        <div className='card-body border-top p-9'>
          <div className='table-responsive'>
            {tickets &&
              <MaterialReactTable
                columns={ticketColumns}
                data={tickets ? tickets : []}
                enableFullScreenToggle={false}
                muiTablePaperProps={{
                  elevation: 0, //change the mui box shadow
                  sx: {
                    borderRadius: '1',
                    backgroundColor: 'unset',
                  },
                }}
                initialState={{
                  columnVisibility: { category: false },
                  density: 'compact',
                  showGlobalFilter: true,
                }}
                muiSearchTextFieldProps={{
                  placeholder: 'Search Ticket',
                  sx: { minWidth: '18rem' },
                  variant: 'outlined',
                  size: 'small',
                }}
                muiTopToolbarProps={{
                  sx: {
                    // backgroundColor: 'unset',
                    marginBottom: "1.5rem",
                    borderRadius: 1
                  }
                }}
                muiBottomToolbarProps={{
                  sx: {
                    fontSize: '1.5rem',
                    borderBottomLeftRadius: '5px',
                    borderBottomRightRadius: '5px',
                  }
                }}
                muiTableHeadCellProps={{
                  sx: {
                    align: 'right',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    fontSize: '1.1rem',
                    borderBottom: '2px solid #9C258F',
                    paddingTop: '10px',
                    paddingLeft: '10px',

                    '&:first-of-type': { borderTopLeftRadius: 5 },
                    '&:last-child': { borderTopRightRadius: 5 }

                  },
                }}
                muiTableBodyCellProps={{
                  sx: {
                    fontSize: '1.1rem',
                    backgroundColor: '#fcfcfc55',
                  }
                }}
                displayColumnDefOptions={{
                  'mrt-row-actions': {
                    muiTableHeadCellProps: { align: 'right' },
                    size: 50,
                  },
                  'mrt-row-expand': {
                    size: 10,
                    muiTableHeadCellProps: { align: 'right', color: '#ff0000' },
                    muiTableBodyCellProps: { align: 'right', },
                  },
                }}
                positionActionsColumn="first"

                renderRowActions={({ row, table }) => (
                  <Box sx={{ display: 'flex', gap: '0.75rem', justifyContent: 'end' }}>
                  </Box>
                )}
              />
            }
          </div>
        </div>
      </div>
    </>






  )
}

export { TableTicket }